import React, { Suspense } from "react";
import { withRouter, Switch, Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import { getUserRole } from "../../utils/UserDetails";
import UserLayout from "../../layouts/UserLayout";
import PrivateRoute from "../../routers/PrivateRoute";
import UserMenus from "./UserMenus";

const App = ({ match }) => {
  return (
    <div className="dashboard-wrapper">
      <UserLayout>
        <Suspense fallback={<div className="loading" />}>
          <Switch>
            <Redirect
              exact
              from={`${match.url}/`}
              to={
                getUserRole() ? `${match.url}/UserMenus` : `${match.url}/login`
              }
            />

            <PrivateRoute
              exact
              path={`${match.url}/permissions`}
              component={UserMenus}
            />
          </Switch>
        </Suspense>
      </UserLayout>
    </div>
  );
};

export default withRouter(connect(null, {})(App));
